import { useQuery } from '@tanstack/react-query';
import { getClaims } from '../api.js';
import { claimStateFor } from '../lib/claimState.js';
import { StatusBadge } from '../components/StatusBadge.js';
import styles from './MyClaimsPage.module.css';

export function MyClaimsPage() {
  // `mine: true` keeps this page correct for managers too — without it they
  // would see the whole clan's claims here instead of just their own.
  const query = useQuery({
    queryKey: ['claims', { mine: true }],
    queryFn: () => getClaims({ mine: true }),
  });

  if (query.isLoading) return <p>Loading…</p>;
  if (query.isError) return <p>{(query.error as Error).message}</p>;

  const claims = query.data?.claims ?? [];

  return (
    <section>
      <h2 className={styles.heading}>My claims</h2>
      {claims.length === 0 && <p className={styles.empty}>You haven't claimed anything yet.</p>}
      <div className={styles.list}>
        {claims.map((claim) => (
          <article key={claim.id} className={styles.row}>
            <div className={styles.rowTop}>
              <span className={styles.title}>{claim.accomplishment.title}</span>
              <StatusBadge state={claimStateFor({ id: claim.id, status: claim.status, reviewNote: claim.reviewNote })} />
            </div>
            <p className={styles.meta}>
              {claim.accomplishment.points} pts · submitted {new Date(claim.submittedAt).toLocaleDateString()}
            </p>
            {claim.reviewNote && <p className={styles.note}>Reviewer note: {claim.reviewNote}</p>}
          </article>
        ))}
      </div>
    </section>
  );
}
